export const TEST = 'TEST';
export const SET_MOBILE_NAV_STATUS = 'SET_MOBILE_NAV_STATUS';
export const SET_MATRIX_SELL_WARNING_MODAL_STATUS = 'SET_MATRIX_SELL_WARNING_MODAL_STATUS';
export const SET_MATRIX_SELL_SUCCESS_MODAL_STATUS = 'SET_MATRIX_SELL_SUCCESS_MODAL_STATUS';
export const SET_WALLET_BUY_MODAL_STATUS = 'SET_WALLET_BUY_MODAL_STATUS';
export const SET_MATRIX_SELL_MODAL_STATUS = 'SET_MATRIX_SELL_MODAL_STATUS';
export const SET_MATRIX_BUY_MODAL_STATUS = 'SET_MATRIX_BUY_MODAL_STATUS';
export const SET_MATRIX_BUY_QR_MODAL_STATUS = 'SET_MATRIX_BUY_QR_MODAL_STATUS';
export const SET_SETTINGS_AVATAR_MODAL_STATUS = 'SET_SETTINGS_AVATAR_MODAL_STATUS';
export const SET_GOOGLE_AUTHENTICATOR_MODAL_STATUS = 'SET_GOOGLE_AUTHENTICATOR_MODAL_STATUS';
export const SET_GOOGLE_AUTHENTICATOR_CONNECT_MODAL_STATUS = 'SET_GOOGLE_AUTHENTICATOR_CONNECT_MODAL_STATUS';
export const SET_REFERRAL_MODAL_STATUS = 'SET_REFERRAL_MODAL_STATUS';

export const GET_USER_DATA_STARTED = 'GET_USER_DATA_STARTED';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';

export const GET_EVENTS_STARTED = 'GET_EVENTS_STARTED';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';

export const CHOICE_EVENT_STARTED = 'CHOICE_EVENT_STARTED';
export const CHOICE_EVENT_SUCCESS = 'CHOICE_EVENT_SUCCESS';
export const CHOICE_EVENT_FAILURE = 'CHOICE_EVENT_FAILURE';

export const GET_CABINET_MAIN_DATA_STARTED = 'GET_CABINET_MAIN_DATA_STARTED';
export const GET_CABINET_MAIN_DATA_SUCCESS = 'GET_CABINET_MAIN_DATA_SUCCESS';
export const GET_CABINET_MAIN_DATA_FAILURE = 'GET_CABINET_MAIN_DATA_FAILURE';

export const GET_CURRENT_EVENT_STARTED = 'GET_CURRENT_EVENT_STARTED';
export const GET_CURRENT_EVENT_SUCCESS = 'GET_CURRENT_EVENT_SUCCESS';
export const GET_CURRENT_EVENT_FAILURE = 'GET_CURRENT_EVENT_FAILURE';

export const GET_TOKEN_DECIMALS_STARTED = 'GET_TOKEN_DECIMALS_STARTED';
export const GET_TOKEN_DECIMALS_SUCCESS = 'GET_TOKEN_DECIMALS_SUCCESS';
export const GET_TOKEN_DECIMALS_FAILURE = 'GET_TOKEN_DECIMALS_FAILURE';

export const GET_ROADMAP_STARTED = 'GET_ROADMAP_STARTED';
export const GET_ROADMAP_SUCCESS = 'GET_ROADMAP_SUCCESS';
export const GET_ROADMAP_FAILURE = 'GET_ROADMAP_FAILURE';

export const GET_LEADERBOARD_STARTED = 'GET_LEADERBOARD_STARTED';
export const GET_LEADERBOARD_SUCCESS = 'GET_LEADERBOARD_SUCCESS';
export const GET_LEADERBOARD_FAILURE = 'GET_LEADERBOARD_FAILURE';

export const GET_MATRIX_STARTED = 'GET_MATRIX_STARTED';
export const GET_MATRIX_SUCCESS = 'GET_MATRIX_SUCCESS';
export const GET_MATRIX_FAILURE = 'GET_MATRIX_FAILURE';

export const GET_REFERRALS_STARTED = 'GET_REFERRALS_STARTED';
export const GET_REFERRALS_SUCCESS = 'GET_REFERRALS_SUCCESS';
export const GET_REFERRALS_FAILURE = 'GET_REFERRALS_FAILURE';
export const RESET_REFERRALS = 'RESET_REFERRALS';

export const GET_REFERRALS_MAIN_STARTED = 'GET_REFERRALS_MAIN_STARTED';
export const GET_REFERRALS_MAIN_SUCCESS = 'GET_REFERRALS_MAIN_SUCCESS';
export const GET_REFERRALS_MAIN_FAILURE = 'GET_REFERRALS_MAIN_FAILURE';

export const GET_CONTEST_WINNERS_STARTED = 'GET_CONTEST_WINNERS_STARTED';
export const GET_CONTEST_WINNERS_SUCCESS = 'GET_CONTEST_WINNERS_SUCCESS';
export const GET_CONTEST_WINNERS_FAILURE = 'GET_CONTEST_WINNERS_FAILURE';

export const GET_CONTEST_WINNERS_DATA_STARTED = 'GET_CONTEST_WINNERS_DATA_STARTED';
export const GET_CONTEST_WINNERS_DATA_SUCCESS = 'GET_CONTEST_WINNERS_DATA_SUCCESS';
export const GET_CONTEST_WINNERS_DATA_FAILURE = 'GET_CONTEST_WINNERS_DATA_FAILURE';

export const SET_REF_CODE_STARTED = 'SET_REF_CODE_STARTED';
export const SET_REF_CODE_SUCCESS = 'SET_REF_CODE_SUCCESS';
export const SET_REF_CODE_FAILURE = 'SET_REF_CODE_FAILURE';

export const SEND_CONNECTED_WALLET_STARTED = 'SEND_CONNECTED_WALLET_STARTED';
export const SEND_CONNECTED_WALLET_SUCCESS = 'SEND_CONNECTED_WALLET_SUCCESS';
export const SEND_CONNECTED_WALLET_FAILURE = 'SEND_CONNECTED_WALLET_FAILURE';

export const GET_TOKEN_COURSE_STARTED = 'GET_TOKEN_COURSE_STARTED';
export const GET_TOKEN_COURSE_SUCCESS = 'GET_TOKEN_COURSE_SUCCESS';
export const GET_TOKEN_COURSE_FAILURE = 'GET_TOKEN_COURSE_FAILURE';

export const SEND_WALLET_AFTER_TRANSACTION_STARTED = 'SEND_WALLET_AFTER_TRANSACTION_STARTED';
export const SEND_WALLET_AFTER_TRANSACTION_SUCCESS = 'SEND_WALLET_AFTER_TRANSACTION_SUCCESS';
export const SEND_WALLET_AFTER_TRANSACTION_FAILURE = 'SEND_WALLET_AFTER_TRANSACTION_FAILURE';

export const GET_RECEIVE_USDT_WALLET_STARTED = 'GET_RECEIVE_USDT_WALLET_STARTED';
export const GET_RECEIVE_USDT_WALLET_SUCCESS = 'GET_RECEIVE_USDT_WALLET_SUCCESS';
export const GET_RECEIVE_USDT_WALLET_FAILURE = 'GET_RECEIVE_USDT_WALLET_FAILURE';

export const GET_CONTEST_INFO_STARTED = 'GET_CONTEST_INFO_STARTED';
export const GET_CONTEST_INFO_SUCCESS = 'GET_CONTEST_INFO_SUCCESS';
export const GET_CONTEST_INFO_FAILURE = 'GET_CONTEST_INFO_FAILURE';

export const CHANGE_PASSWORD_STARTED = 'CHANGE_PASSWORD_STARTED';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const CHANGE_AVATAR_STARTED = 'CHANGE_AVATAR_STARTED';
export const CHANGE_AVATAR_SUCCESS = 'CHANGE_AVATAR_SUCCESS';
export const CHANGE_AVATAR_FAILURE = 'CHANGE_AVATAR_FAILURE';

export const GET_TRANSACTIONS_STARTED = 'GET_TRANSACTIONS_STARTED';
export const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
export const GET_TRANSACTIONS_FAILURE = 'GET_TRANSACTIONS_FAILURE';

export const SET_BUY_REQUEST_STARTED = 'SET_BUY_REQUEST_STARTED';
export const SET_BUY_REQUEST_SUCCESS = 'SET_BUY_REQUEST_SUCCESS';
export const SET_BUY_REQUEST_FAILURE = 'SET_BUY_REQUEST_FAILURE';

export const SET_BUY_REQUEST_CANCEL_STARTED = 'SET_BUY_REQUEST_CANCEL_STARTED';
export const SET_BUY_REQUEST_CANCEL_SUCCESS = 'SET_BUY_REQUEST_CANCEL_SUCCESS';
export const SET_BUY_REQUEST_CANCEL_FAILURE = 'SET_BUY_REQUEST_CANCEL_FAILURE';

export const SET_BUY_REQUEST_CONFIRM_STARTED = 'SET_BUY_REQUEST_CONFIRM_STARTED';
export const SET_BUY_REQUEST_CONFIRM_SUCCESS = 'SET_BUY_REQUEST_CONFIRM_SUCCESS';
export const SET_BUY_REQUEST_CONFIRM_FAILURE = 'SET_BUY_REQUEST_CONFIRM_FAILURE';

export const GET_DEPOSIT_LINK_STARTED = 'GET_DEPOSIT_LINK_STARTED';
export const GET_DEPOSIT_LINK_SUCCESS = 'GET_DEPOSIT_LINK_SUCCESS';
export const GET_DEPOSIT_LINK_FAILURE = 'GET_DEPOSIT_LINK_FAILURE';

export const GET_GOOGLE_CONNECT_QR_STARTED = 'GET_GOOGLE_CONNECT_QR_STARTED';
export const GET_GOOGLE_CONNECT_QR_SUCCESS = 'GET_GOOGLE_CONNECT_QR_SUCCESS';
export const GET_GOOGLE_CONNECT_QR_FAILURE = 'GET_GOOGLE_CONNECT_QR_FAILURE';

export const SET_GOOGLE_CODE_STARTED = 'SET_GOOGLE_CODE_STARTED';
export const SET_GOOGLE_CODE_SUCCESS = 'SET_GOOGLE_CODE_SUCCESS';
export const SET_GOOGLE_CODE_FAILURE = 'SET_GOOGLE_CODE_FAILURE';

export const SELL_TOKENS_STARTED = 'SELL_TOKENS_STARTED';
export const SELL_TOKENS_SUCCESS = 'SELL_TOKENS_SUCCESS';
export const SELL_TOKENS_FAILURE = 'SELL_TOKENS_FAILURE';

export const WITHDRAW_STARTED = 'WITHDRAW_STARTED';
export const WITHDRAW_SUCCESS = 'WITHDRAW_SUCCESS';
export const WITHDRAW_FAILURE = 'WITHDRAW_FAILURE';

export const GET_WALLET_HISTORY_STARTED = 'GET_WALLET_HISTORY_STARTED';
export const GET_WALLET_HISTORY_SUCCESS = 'GET_WALLET_HISTORY_SUCCESS';
export const GET_WALLET_HISTORY_FAILURE = 'GET_WALLET_HISTORY_FAILURE';

export const GET_REFERRAL_AWARDS_STARTED = 'GET_REFERRAL_AWARDS_STARTED';
export const GET_REFERRAL_AWARDS_SUCCESS = 'GET_REFERRAL_AWARDS_SUCCESS';
export const GET_REFERRAL_AWARDS_FAILURE = 'GET_REFERRAL_AWARDS_FAILURE';

export const GET_RESET_CODE_STARTED = 'GET_RESET_CODE_STARTED';
export const GET_RESET_CODE_SUCCESS = 'GET_RESET_CODE_SUCCESS';
export const GET_RESET_CODE_FAILURE = 'GET_RESET_CODE_FAILURE';

